/**
 * Create Enhancement Bundle API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../../axiosInstance';
import { EnhancementBundle } from '../types';

interface CreateBundleResponse {
  bundle: EnhancementBundle;
}

export const createEnhancementBundle = async (bundle: EnhancementBundle): Promise<EnhancementBundle> => {
  const response = await axiosInstance.post<CreateBundleResponse>(
    '/api/enhancement-bundles',
    bundle
  );

  return response.data.bundle;
};
